import React, { useState, useEffect, createContext, useContext, useReducer, Reducer } from 'react'
import ReactDOM from 'react-dom'

import { ThemeProvider } from '@intelie/ui'
import liveTheme, { mergeIntelieUiTheme } from 'live/services/theme'
import LiveHeader from 'live/components/header/ui/main/main'
import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'

import styled from 'styled-components'

import { ReportHeader } from '../src/components/Header/Header'
import ReportBody from '../src/components/Body/styles'

import init from '../init'
import { ReportsApprovalTypes } from './types/ReportsApproval'
import { ReportsApprovalList } from './components/ReportsApprovalList/ReportsApprovalList'
import { ModalApprovalSettings } from '../approval-settings/ModalApprovalSettings'
import { ScheduleData } from './SheduleActionType'
import { getApprovalSettings, updateApprovalSettings } from '../approval-settings/api/api'
import { ApprovalSettingsType } from '../approval-settings/types/ApprovalSettings'
import { validateFields } from '../src/utils/utils'
import { Notification } from '../approval-settings/components/Notification'

const locale = window.Live.settings && window.Live.settings.locale ? window.Live.settings.locale : null
const isPT_BR = locale === 'pt_br'

const App = ({ children, className }): JSX.Element => {
    const [top, setTop] = useState(0)

    useEffect(() => {
        setTop(document.querySelector('nav').getBoundingClientRect().height)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [document.querySelector('nav')])

    return (
        <AppStyles className={className}>
            <LiveHeader />
            <div className={'inner-app'} style={{ top }}>
                {children}
            </div>
        </AppStyles>
    )
}

const AppStyles = styled.div`
    position: relative;
    height: 100%;

    .inner-app {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: 0;
        width: 100%;
    }
`

export interface ContextReportApproval {
    reportApproval: ReportsApprovalTypes
    dispatch: (state: any) => void
}

const initContextReportsApproval = {
    reportApproval: undefined,
    dispatch: undefined
} as ContextReportApproval

const ReportsApprovalContext = createContext<ContextReportApproval>(initContextReportsApproval)

function reducer(state, action) {
    return {
        ...state,
        ...action
    }
}

const ReportsApproval = (): JSX.Element => {
    const [state, dispatch] = useReducer<Reducer<ContextReportApproval, any>>(reducer, initContextReportsApproval)

    return (
        <ThemeProvider cssVarsSelector=":root" themeMerger={mergeWithLiveTheme}>
            <ReportsApprovalContext.Provider value={{ ...state, dispatch }}>
                <App className="app-container">
                    <ReportHeader />
                    <ReportBody id="reports-approval-app-body">
                        <ReportsApprovalList />
                    </ReportBody>
                </App>
            </ReportsApprovalContext.Provider>
        </ThemeProvider>
    )
}

const mergeWithLiveTheme = theme => {
    const merged = mergeIntelieUiTheme(theme, liveTheme)
    return merged
}

enum ScheduleType {
    Date = 0,
    Recurrent = 1,
    Rule = 2
}

document.addEventListener('DOMContentLoaded', () => {
    if (location?.pathname?.includes('/app/reports_approval')) {
        ReactDOM.render(<ReportsApproval />, document.getElementById('main-content'))
        init()
    } else if (location?.pathname?.includes('/app/reports_maker')) {
        const SheduleAction = require('plugin-reports-maker/shared/SheduleAction')

        SheduleAction.RegisterSheduleAction({
            Component: ModalApprovalSettings,
            name: 'Approval Settings Modal',
            iconFontawesome: 'fas fa-tasks',
            type: ScheduleType.Rule,
            loadData(schedule: ScheduleData) {
                return getApprovalSettings(schedule?.settings?.uuid)
            },
            submitData(data: ApprovalSettingsType, schedule: ScheduleData) {
                const validate = validateFields(data)

                if (validate.pass) {
                    return updateApprovalSettings(data)
                } else {
                    globalNotification.error(
                        <Notification
                            title={
                                isPT_BR
                                    ? 'Erro ao tentar salvar as configurações de aprovação: '
                                    : 'Error trying to save the approval settings: '
                            }
                        >
                            {validate.message}
                        </Notification>,
                        20
                    )
                }
            }
        })
    }
})

export { ReportsApprovalContext }
